module.exports = __webpack_public_path__ + "static/media/left-arrow.e16a1425.png";